import { useState, useEffect } from 'react';

export default function useSkipLinks() {
  const [skipLinks, setSkipLinks] = useState([]);

  useEffect(() => {
    const skipLinkElements = document.querySelectorAll(
      '[data-skip-link]:not(pre):not(code)',
    );
    const links = Array.prototype.slice.call(skipLinkElements).map((skipLink) => ({
      title: skipLink.dataset.skipLink,
      id: skipLink.id,
    }));
    setSkipLinks(links);
  }, []);

  return { skipLinks };
}
